import React from "react";
import { defineMessages } from "react-intl";
import { Chip } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { Button } from "../../../components/button/Buttons.js";
import "../../../components/button/EditButton.js";
const localized = defineMessages({
  addBulkAction: {
    id: "BulkApplyStepModalButton_addBulkAction",
    defaultMessage: "Add Bulk Action"
  }
});
const useBulkOpenActionsModalButtonStyles = makeStyles()((theme) => ({
  bulkApplyStepModalButton: {
    display: "flex",
    alignItems: "center",
    borderRadius: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  bulkApplyStepModalButtonChip: {
    marginLeft: theme.spacing(0.75),
    height: theme.spacing(2.5),
    ...theme.typography.subtitle2
  },
  bulkApplyStepModalButtonChipPrimary: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.contrastText
  }
}));
function BulkActionButton({ label, startIcon, itemsCount, onClick, disabled, color = "primary", ...props }) {
  const { classes, cx } = useBulkOpenActionsModalButtonStyles();
  const hasSelectedItems = itemsCount > 0;
  return /* @__PURE__ */ React.createElement(
    Button,
    {
      className: classes.bulkApplyStepModalButton,
      label: label ?? localized.addBulkAction,
      color,
      onClick,
      startIcon,
      disabled: disabled || !hasSelectedItems,
      ...props
    },
    hasSelectedItems ? /* @__PURE__ */ React.createElement(
      Chip,
      {
        label: itemsCount,
        size: "small",
        className: cx(classes.bulkApplyStepModalButtonChip, color === "primary" && classes.bulkApplyStepModalButtonChipPrimary)
      }
    ) : null
  );
}
export {
  BulkActionButton
};
//# sourceMappingURL=BulkActionButton.js.map
